import { render, staticRenderFns } from "./addUserComment.vue?vue&type=template&id=002ce3e0"
import script from "./addUserComment.vue?vue&type=script&lang=js"
export * from "./addUserComment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports